/**
 * Strip highlight markers from text
 */
export const cleanExcerpt: (text: string) => string = (text: string): string =>
	text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
